import React, { useState } from 'react';
import { Card, DatePicker, Typography, Space } from 'antd';
import Chart from 'react-apexcharts';
import dayjs from 'dayjs';

const { Title, Text, Link } = Typography;

const ReportingSales = () => {
    const [startDate, setStartDate] = useState(dayjs('2026-03-18'));
    const [endDate, setEndDate] = useState(dayjs('2026-04-17'));

    const chartOptions = {
        chart: {
            type: 'line',
            toolbar: { show: false },
            zoom: { enabled: false }
        },
        colors: ['#10b981', '#0ea5e9'], // green and blue
        stroke: {
            curve: 'straight',
            width: 2
        },
        grid: {
            borderColor: '#f1f5f9',
            strokeDashArray: 4,
            xaxis: { lines: { show: true } },
            yaxis: { lines: { show: true } }
        },
        xaxis: {
            categories: [
                '18 Mar', '19 Mar', '20 Mar', '21 Mar', '22 Mar', '23 Mar', '24 Mar', '25 Mar', '26 Mar', '27 Mar', 
                '28 Mar', '29 Mar', '30 Mar', '31 Mar', '01 Apr', '02 Apr', '03 Apr', '04 Apr', '05 Apr', '06 Apr', 
                '07 Apr', '08 Apr', '09 Apr', '10 Apr', '11 Apr', '12 Apr', '13 Apr', '14 Apr', '15 Apr'
            ],
            labels: {
                style: { colors: '#64748b', fontSize: '11px' }
            },
            axisBorder: { show: true, color: '#e2e8f0' },
            axisTicks: { show: true, color: '#e2e8f0' }
        },
        yaxis: {
            min: 0,
            max: 1.0,
            tickAmount: 10,
            labels: {
                style: { colors: '#64748b', fontSize: '11px' },
                formatter: (value) => value.toFixed(1)
            }
        },
        legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            markers: { radius: 12 },
            itemMargin: { horizontal: 15, vertical: 20 }
        },
        dataLabels: { enabled: false }
    };

    const chartSeries = [
        {
            name: '16 Feb 2026 - 18 Mar 2026',
            data: new Array(29).fill(0)
        },
        {
            name: '18 Mar 2026 - 17 Apr 2026',
            data: new Array(29).fill(0)
        }
    ];

    return (
        <div style={{ padding: '24px', backgroundColor: '#f8fafc', minHeight: '100vh', borderRadius: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                <Title level={3} style={{ margin: 0, fontWeight: 600, color: '#0f172a' }}>Sales</Title>
                <Space>
                    <DatePicker value={startDate} onChange={setStartDate} format="YYYY-MM-DD" style={{ width: 140, borderRadius: '6px' }} />
                    <DatePicker value={endDate} onChange={setEndDate} format="YYYY-MM-DD" style={{ width: 140, borderRadius: '6px' }} />
                </Space>
            </div>

            <Card bordered={true} style={{ borderRadius: '8px', borderColor: '#e2e8f0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
                    <div>
                        <Text style={{ color: '#64748b', fontSize: '14px', fontWeight: 500 }}>Total Sales</Text>
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px', marginTop: '4px', marginBottom: '4px' }}>
                            <Title level={2} style={{ margin: 0, color: '#334155', fontWeight: 700 }}>$0.00</Title>
                            <Text style={{ color: '#10b981', fontWeight: 500, fontSize: '14px' }}>0% &uarr;</Text>
                        </div>
                        <Text style={{ color: '#64748b', fontSize: '14px' }}>Sales Over Time</Text>
                    </div>
                    <Link href="#" style={{ color: '#3b82f6', fontSize: '14px', fontWeight: 500 }}>View Details</Link>
                </div>

                <div style={{ height: 400 }}>
                    <Chart options={chartOptions} series={chartSeries} type="line" height="100%" />
                </div>
            </Card>
        </div>
    );
};

export default ReportingSales;
